import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Blogs/BlogsLobby.tsx");
